import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ActiveComponentService {
  private activeComponents = new BehaviorSubject<string[]>([]);
  activeComponent$ = this.activeComponents.asObservable();

  setActiveComponent(componentName: string): void {
    const currentComponents = this.activeComponents.value;
    if (!currentComponents.includes(componentName)) {
      this.activeComponents.next([...currentComponents, componentName]);
    }
  }

  reset(): void {
    this.activeComponents.next([]);
  }
}
